import React from 'react';
import { Form, Select } from 'antd';

// https://ant.design/components/select
const FormSelect = ({
  label,
  name,
  options,
  mode,
  rules,
  initialValue,
  help,
  extra,
  size,
  formItemStyle,
  ...rest
}) => {
  // noinspection XmlDeprecatedElement
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      initialValue={initialValue}
      help={help}
      extra={extra}
      style={formItemStyle}
    >
      <Select
        {...rest}
        allowClear
        mode={mode}
        options={options}
        size={size}
        showSearch
        filterOption={(input, option) => {
          if (typeof option?.label === 'object' || !option?.label) {
            return false;
          }
          return String(option.label)
            .toLowerCase()
            .includes(input.toLowerCase());
        }}
      />
    </Form.Item>
  );
};

export default FormSelect;
